// extracted by mini-css-extract-plugin
export default {"container":"container_hofV2","item":"item_GHlF2"};